/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-send-alt-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.319 2.681a.625.625 0 00-.656-.143l-13.75 5a.625.625 0 000 1.168L8.28 10.85l3.963-3.975.881.881-3.981 3.982 2.15 5.368a.625.625 0 00.581.394.625.625 0 00.575-.413l5-13.75a.625.625 0 00-.131-.656z"/>'
  }
})
